/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { compact } from 'lodash';

import { BlendBridge } from 'blb-types/blendBridge';

import { inputFormatters } from '@blend/shared-react';
import { Text } from '@blend/enterprise-components';

import * as format from 'blb-utils/format';
import { cardWrapperStyles, SectionCard } from '../DashboardPage/SectionCard';

export const styles = StyleSheet.create({
  contactDescriptor: {
    marginLeft: -3,
  },
});

export const ContactCard: React.FC<{
  contact: BlendBridge.API.UserProfileNoAddress;
  editButton?: React.ReactNode;
}> = ({ contact, editButton }) => {
  const contactNumber = contact.phoneNumber && inputFormatters.PHONE.format(contact.phoneNumber.toString());
  const fullName = format.fullName(contact);
  const subtitle = compact([contact.email, contactNumber]).join(' • ');

  return (
    <div className={css(cardWrapperStyles.singleCardWrapper)} key={fullName}>
      <SectionCard
        header={fullName}
        headerChildren={
          contact.label && (
            <p className={css(styles.contactDescriptor)}>
              <Text fontSize="sm">- {contact.label}</Text>
            </p>
          )
        }
        id={`it-Contact-${contact.firstName}-${contact.lastName}`}
        sectionActions={editButton}
        subtitle={subtitle}
      />
    </div>
  );
};
